<template>
    <section>
        <!-- v-if="detailData?.detail?.center_normal_stone_shape" -->
        <section class="diamonddetail">
            <div>
                <div class="fancyTitle">
                    <div class="mb-2 title_flex" @click="toggleRing()"
                        v-if="['hues-ring', 'soiree-ring'].includes(detailData.sub_type)">
                    </div>
                </div>
                <div class="setting_details">
                    <div class="mb-2 title_flex" @click="toggledouble()">
                        <div class="font-active">
                            Diamond Details
                        </div>
                        <SvgHeaderSvg class="for_mobile" :type="drowdown1 ? 'up' : 'down'" />
                    </div>

                    <div class="ring_data_flex" :class="drowdown1 ? 'show' : 'hide'">
                        <!-- Common like SIDE TOTAL WEIGHT -->
                        <div class="ring_box" @click="showModal('carat', modalParams?.carat?.weight1)">
                            <div class="ring_box_left">
                                <h5 class="title_h5 caps"> {{ currentCarat?.label }}. tw
                                </h5>
                                <p class="mb-0">Total Carat Weight</p>
                            </div>
                            <div class="ring_box_right">
                                <img width="100" height="72" src="~/assets/loose_setting/totalctwt.svg"
                                    alt="Total CT WT" />
                            </div>
                            <div class="top-icon">
                                <SvgHeaderSvg :type="'ask'" />
                            </div>
                        </div>
                        <!-- Common For SIDEQuantity -->
                        <div class="ring_box" @click="showModal('carat', modalParams?.carat?.quantity)">
                            <div class="ring_box_left">
                                <h5 class="title_h5 caps">{{ addtionalAttirbute?.num_lots }}</h5>
                                <p class="mb-0">Diamond Quantity</p>
                            </div>
                            <div class="ring_box_right pe-md-1">
                                <img src="/public/loose_setting/diamond.svg" alt="Diamond">
                            </div>
                            <div class="top-icon">
                                <SvgHeaderSvg :type="'ask'" />
                            </div>
                        </div>
                        <!-- Common For SIDECLARITY -->
                        <div class="ring_box" @click="showModal('colorClarity', modalParams?.colorClarity?.avgClarity)">
                            <div class="ring_box_left">
                                <h5 class="title_h5 caps">{{ stoneClarity}}</h5>
                                <p class="mb-0">Diamond Clarity</p>
                            </div>
                            <div class="ring_box_right mt-md-2">
                                <img width="100" height="72" :src="'/loose_setting/' + lowercase(stoneClarity) + '.svg'"
                                    alt="Style" />
                            </div>
                            <div class="top-icon">
                                <SvgHeaderSvg :type="'ask'" />
                            </div>
                        </div>
                        <!-- COMMON FOR SIDECOLOR -->
                        <div class="ring_box" @click="showModal('colorClarity', modalParams?.colorClarity?.avgColor)"
                            v-if="isHuesRing || isSoireeEarring">
                            <div class="ring_box_left">
                                <h5 class="title_h5 caps truncate" v-if="formattedStoneColors">{{formattedStoneColors}}
                                </h5>
                                <p class="mb-0">Diamond Color</p>
                            </div>
                            <div class="ring_box_right mt-md-2">
                                <img width="100" height="72" src="/public/loose_setting/fancycoloroicon.svg"
                                    alt="Side Stone Color" />
                            </div>
                            <div class="top-icon">
                                <SvgHeaderSvg :type="'ask'" />
                            </div>
                        </div>
                        <div class="ring_box" @click="showModal('colorClarity', modalParams?.colorClarity?.avgColor)"
                            v-if="isSoireeRing">
                            <div class="ring_box_left">
                                <h5 class="title_h5 caps">{{stoneColor}}
                                </h5>
                                <p class="mb-0">Diamond Color</p>
                            </div>
                            <div class="ring_box_right mt-md-2">
                                <img width="100" height="72" :src="'/loose_setting/' + lowercase(stoneColor) + '.svg'"
                                    alt="Style" />
                            </div>
                            <div class="top-icon">
                                <SvgHeaderSvg :type="'ask'" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="tableSection mt-3">
            <div class="table_skeleton" v-if="loader">
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
            </div>

            <div :class="{'fullFancy' : tableData.length}" v-if="!loader && tableData">
                <div :class="index === 0 ? 'headers' : 'cell'" v-for="(d,index) in tableData" :key="d.id">
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col1)">{{ d.col1 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col2)">{{ d.col2 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col3)">{{ d.col3 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col4)">{{ d.col4 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col5)">
                        <span v-if="index === 0">{{ tableData[0].col5 }}</span>
                        <span :class="d.col5" v-else>{{$formatExactCarat(d.col5)}} ct. tw</span>
                    </p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col6)">{{ d.col6 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col7)">{{ d.col7 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col8)">{{ d.col8 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col9)">{{ d.col9 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col10)">{{ d.col10 }}</p>
                </div>
            </div>

        </section>
        <p class="mb-0 table_text">*The total carat weight mentioned is the minimum total carat weight of the product.</p>
        <div class="mt-3 mt-md-4" v-if="currentCarat">
            <div class="ring_title mb-2 ms-md-2">
                <span class="prod_title">{{ currentCarat?.product_name }}</span>
                <span class="for_desktop"> | </span>
                <span class="prod_sku">SKU : {{ currentMetal?.main_sku }}</span>
            </div>
            <div class="ring_desc ms-md-2">
                <span>{{ currentCarat?.long_desc }}</span>
            </div>
        </div>

        <CommonCustomModal v-model="flagShowModal" :size="'sm'">

            <div v-for="(isOpen, type) in modalFlagsComputed" :key="type">
                <ModalCover v-if="isOpen" :id="`modal-${modalBoxes[type]}`" :type="type" :boxValue="modalBoxes[type]"
                    :item="detailData?.detail" :params="modalParams"
                    :currentColor="detailData?.detail?.side_normal_stone_d_color"
                    :currentCarat="currentCarat" :addtionalAttirbute="addtionalAttirbute"
                    :currentClarity="detailData?.detail.side_normal_stone_d_clarity" :detailData="detailData" />
            </div>

        </CommonCustomModal>
    </section>
</template>

<script setup>
import { shopdetailStore } from '@/stores/shop_detail/shop_detail';
const store = shopdetailStore()
const dropring = ref(true);
const drowdown1 = ref(true);
const route = useRoute()
const {$formatExactCarat , $formatCarat} = useNuxtApp()
const flagShowModal = ref(false);
const tabs = reactive({
    setting: true,
    cen_stone: false,
    accent_stone: false,
})

const loader = ref(false)

const toggleRing = () => {
    dropring.value = !dropring.value;
};
const lowercase = (value) => {
    return value?.toLowerCase().replace(/[^\w\s]/gi, '');
}

const toggledouble = () => {
    drowdown1.value = !drowdown1.value;
};
const emit = defineEmits(['close']);
const detailData = computed(() => {
    return store.getDetailData
})

// console.log(detailData.value,'detailData');

const id = detailData.value.main_sku;

// console.log(id,'detail idddd');

const tableData = ref([])


const currentMetal = computed(() => {
    return store.getCurrentActive('metal')
})

const currentCarat = computed(() => {
    return store.getCurrentActive('carat')
})

const addtionalData = computed(() => {
    return store.getAdditionalDetails
})

const labelSettingDetail = computed(() => {

    const sub_type = detailData.value.sub_type

    const rings = ['full-eternity-ring', 'toi-et-moi-ring', 'anniversary-ring', 'couple-bands-ring', 'band-ring']
    const eng_rings = ['engagement-ring', 'in-stock-ring', 'in-stock-pendant', 'in-stock-earring']
    const bracelets = ['tennis-bracelet']
    const necklaces = ['tennis-necklace', 'solitaire-necklace']
    const studs = ['earring', 'stud-earring', 'fashion-earring']
    const hoops = ['hoop-earring']
    const hues = ["hues-ring", "soiree-ring"]

    if (!sub_type) {

        return ''
    } else if (rings.includes(sub_type)) {

        return 'Band Details'
    }
    else if (eng_rings.includes(sub_type)) {

        return 'Setting Details'
    }
    else if (bracelets.includes(sub_type)) {

        return 'Bracelet Details'
    }
    else if (necklaces.includes(sub_type)) {

        return 'Necklace Details'
    }
    else if (studs.includes(sub_type)) {

        return 'Stud Details'
    }
    else if (hoops.includes(sub_type)) {

        return 'Hoop Details'
    }
    else if (hues.includes(sub_type)) {

        return 'Fancy Details'
    }
    return ''

})

const currentSize = computed(() => {
    let type
    if (['tennis-necklace', 'solitaire-necklace', 'tennis-bracelet'].includes(detailData.value.sub_type)) {
        type = 'chain_length'
    }

    if (['stud-earring' || 'fashion-earring'].includes(detailData.value.sub_type)) {
        type = 'back_type'
    }
    if (['full-eternity-ring', 'toi-et-moi-ring', 'band-ring', 'anniversary-ring'].includes(detailData.value.sub_type)) {
        type = 'size'
    }
    if (['couple-bands-ring'].includes(detailData.value.sub_type)) {
        type = 'his_size'
    }

    return store.getCurrentActiveAttribute(type)
})

const addtionalAttirbute = computed(() => {
    let size = null
    if (currentSize.value) {
        size = currentSize.value.value
    }
    if (addtionalData.value && size !== undefined) {

        const filteredData = addtionalData.value.find(cv => cv.size_attribute == size)

        if (filteredData !== undefined) {

            return filteredData
        }
    }
    if (currentCarat.value !== undefined) {

        return currentCarat.value
    }

    return null
})



const numLots = computed(() => {

    const filteredData = addtionalAttirbute.value

    if (filteredData !== null) {

        return filteredData.num_lots
    }

    if (currentCarat.value !== undefined) {

        return currentCarat.value.num_lots
    }

    return ''

})


function toggleDetails(type) {
    tabs.setting = false
    tabs.accent_stone = false
    tabs.cen_stone = false

    tabs[type] = true
}


const getDetail = async () => {

    loader.value = true;
    
    try {
        const res = await $fetch(useCountryPath(`config/shop/jewelry-detail/${id}`))
        
        tableData.value = res.data

        loader.value = false;
        
    } catch (error) {
        console.log(error);
        
    }

}

getDetail();


onMounted(async () => {
    await store.setAdditionalDetails({ slug: route.params.slug })
    
})

const dropdowns = reactive({
    1: false,
    2: false
});

function toggleBox(diamondNumber) {
    dropdowns[diamondNumber] = !dropdowns[diamondNumber];
}

const stoneColor = computed(() => {
  return detailData.value?.detail?.side_normal_stone_d_color ||
         detailData.value?.detail?.center_color_stone_d_color ||
         detailData.value?.detail?.center_normal_stone_d_color || '';
});
const stoneClarity = computed(() => {
  return detailData.value?.detail?.side_normal_stone_d_clarity ||
         detailData.value?.detail?.center_color_stone_d_clarity ||
         detailData.value?.detail?.center_normal_stone_d_clarity || '';
});
const modalFlags = ref({
    colorClarity: false,
    carat: false,
});

const modalBoxes = ref({
    colorClarity: '',
    carat: '',
});

const modalParams = {
    colorClarity: { avgColor: 'avgColor', avgClarity: 'avgClarity' },
    carat: { weight1: 'weight1', quantity: 'quantity' },
};

// Computed property to calculate modalFlags based on modalBoxes
const modalFlagsComputed = computed(() => {
    const computedFlags = {};
    Object.keys(modalFlags.value).forEach((key) => {
        computedFlags[key] = modalFlags.value[key] && modalBoxes.value[key] !== '';
    });
    return computedFlags;
});

const showModal = (type, boxValue) => {
    Object.keys(modalFlags.value).forEach((modalType) => {
        modalFlags.value[modalType] = false;
        modalBoxes.value[modalType] = '';
    });

    modalFlags.value[type] = true;
    modalBoxes.value[type] = boxValue;
    flagShowModal.value = true;
};
const isSoireeRing = computed(() => detailData?.value?.sub_type === 'soiree-ring');
const isHuesRing = computed(() => detailData?.value?.sub_type === 'hues-ring');
const isSoireeEarring = computed(()=> detailData?.value?.sub_type === 'soiree-earring')
const formattedStoneColors = computed(() => {
    const sideNormalColor = detailData.value?.detail?.side_normal_stone_d_color;
    const centerNormalColor = detailData.value?.detail?.center_normal_stone_d_color;
    const sideColor = detailData.value?.detail?.side_color_stone_d_color;
    const centerColor = detailData.value?.detail?.center_color_stone_d_color;

    // console.log("centerNormalColor:", centerNormalColor);
    // console.log("sideNormalColor:", sideNormalColor);
    // console.log("centerColor:", centerColor);
    // console.log("sideColor:", sideColor);
    const firstColor =  sideNormalColor || centerNormalColor;
    const secondColor = centerColor || sideColor || centerNormalColor;

    // console.log("firstColor:", firstColor);
    // console.log("secondColor:", secondColor);

    let colors = '';

    if (firstColor && secondColor && firstColor !== secondColor) {
        colors = firstColor + ", " + secondColor;
    } 
    else if (firstColor) {
        colors = firstColor;
    } 
    else if (secondColor) {
        colors = secondColor;
    } 
    else {
        colors = '';
    }

    // console.log("colors before replace:", colors);

    return colors.replace(/,([^ ])/g, ', $1');
});

</script>

<style scoped>
.table_skeleton {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.skeleton {
  height: 32px;
  width: 1180px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.3);
  mask-image: radial-gradient(white, black);
  cursor: wait;
  overflow: hidden;
  margin-bottom: 10px;
}

.table_text{
    font-size: 14px;
    font-style: italic;
    color: #909090;
    padding-left: 16px;
}
.tableSection {
    overflow-x: auto;
}
.fullFancy{
    overflow-x: auto;
    width: 1180px;
    margin: 0 auto;
    text-align: center;
    border-radius: 4px;
    /* padding-bottom: 5px; */
    margin-bottom: 5px;
    border: 1px solid #c4c4c4;
}
.headers, .cell{
    display: flex;
}
.headers{
    background: #f5f5f5;
    font-weight: 600;
}
.headers p , .cell p {
    width: 25%;
    padding: 4px;
    border-right: 1px solid #c4c4c4;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cell p{
    color: #353535;
    font-weight: 500;
}
.headers , .cell {
    border-bottom: 1px solid #c4c4c4;
}
.headers p:last-child , .cell p:last-child {
    border-right: 0;
    
}
.cell:last-child{
    border-bottom: 0;
}

.title_flex {
    font-size: 28px;
    text-align: center;
    color: #242529;
    text-transform: capitalize;
}

.ring_data_flex {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
}

.ring_box {
    width: 23%;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    margin: 10px;
    padding: 13px;
    position: relative;
    display: flex;
    align-items: flex-start;
    min-height: 100px;
    cursor: pointer;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.hoop_mod {
    cursor: default;
}

.top-icon {
    position: absolute;
    top: 4px;
    right: 2px;
    cursor: pointer;
}

.ring_box_left {
    width: 60%;
}

.ring_box_right {
    width: 40%;
    text-align: right;
}

h5 {
    font-size: 20px;
    color: #212529;
    text-transform: capitalize;
    font-weight: 600;
    margin-bottom: 5px;
}

.ring_box_left p {
    font-size: 14px;
    color: #606060;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.ring_desc {
    font-size: 16px;
    color: #606060;
}

.prod_sku {
    font-size: 16px;
    color: #606060;
}

.prod_title {
    font-size: 16px;
    color: #353535;
    font-weight: 600;
}

.non_cap {
    text-transform: lowercase;
}

@media(max-width: 1250px) {

    h5 {
        font-size: 18px;
    }
    .table_text{
    padding-left: 0;
}
}

@media(max-width: 1150px) {
    .ring_box {
        margin: 5px;
    }

    h5 {
        font-size: 16px;
    }

    .tableSection {
        padding-left: 20px;
    }
}

@media(max-width: 992px) {
    .ring_data_flex {
        flex-wrap: wrap;
        /* justify-content: space-between; */
    }

    .ring_box {
        width: 31%;
        margin: 7px;

    }

    .tableSection {
        padding-left: 0;
    }

}

@media(max-width: 767px) {
    .ring_data_flex.hide {
        display: none;
    }
 
    .ring_data_flex {
        justify-content: space-between;
    }

    .ring_box {
        width: 48%;
        flex-wrap: wrap;
        flex-direction: column-reverse;
        padding: 13px 5px;
        margin: 6px 0;
        min-height: 155px;
    }

    .ring_box_left,
    .ring_box_right {
        width: 100%;
        text-align: center;
    }

    .ring_box_left p {
        font-size: 12px;
    }

    .title_flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
    }

    .ring_box_left {
        margin-top: 10px;
    }

    .prod_title,
    .prod_sku,
    .ring_desc {
        font-size: 14px;
        display: block;
    }
}
</style>